import { useState, useEffect, createContext, useContext } from "react";
import { useAuth } from "./AuthContext";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const AccessContext = createContext(null);

export function AccessProvider({ children }) {
  const { user } = useAuth();
  const [snapshot, setSnapshot] = useState(null);
  // A response belongs to the auth snapshot that requested it. Never display
  // the previous account's access while a replacement request is pending.
  const access = snapshot && snapshot.owner === user ? snapshot.data : null;

  useEffect(() => {
    let active = true;
    setSnapshot(null);
    if (!user) {
      return;
    }
    const fetch = async () => {
      try {
        const { data } = await axios.get(`${API_URL}/api/access/features`, { withCredentials: true });
        if (active) setSnapshot({ owner: user, data });
      } catch {
        if (active) setSnapshot({ owner: user,
          data: { account_type: "unknown", features: {}, upgrade_date: null } });
      }
    };
    fetch();
    return () => { active = false; };
  }, [user, user?.subscription_status]);

  const isPaid = access?.account_type === "paid";
  const canAccess = (feature) => {
    if (!access) return true;
    if (user?.role === "admin") return true;
    return access.features[feature] !== false;
  };

  return (
    <AccessContext.Provider value={{ access, isPaid, canAccess }}>
      {children}
    </AccessContext.Provider>
  );
}

export function useAccess() {
  const context = useContext(AccessContext);
  if (!context) {
    return { access: null, isPaid: false, canAccess: () => true };
  }
  return context;
}
